/**
 * 브랜드 명칭·법인 정보 SSoT.
 * 셸(헤더·푸터)·문서 타이틀 등 하드코딩 문구는 전부 이 설정을 참조한다.
 */
export const brand = {
  /** 서비스 워드마크 */
  name: 'AdvisorDesk',
  /** 발행 그룹/법인 */
  group: '제이앤디소프트',
  /** 문서 타이틀·메타 설명용 한 줄 */
  tagline: '경영지도사를 위한 고객사·업무 관리 워크스페이스',
  /** 로고 락업 슬로건(로고 자산의 서브 타이틀 문구) — BrandLogo tagline 옵트인 렌더 전용 */
  slogan: '경영지도사의 업무를 더 스마트하게',
  /** 워드마크 2색 분절 — primary(네이비) + accent(액센트 블루) */
  wordmark: { primary: 'Advisor', accent: 'Desk' },
  /**
   * 워크스페이스 진입 경로 — 통합 React 앱에서는 같은 라우터의 내부 경로(`/workspace`).
   * 운영 URL 규약(`/workspace/*`)은 그대로 유지하되, 별도 앱이 아니므로 <Link> 로 이동한다.
   */
  workspaceUrl: '/workspace',
  /** 정식 로고 이미지 자산(아이콘+워드마크+태그라인 락업) — OG 등 큰 자리용 보존. 셸 렌더는 BrandLogo(텍스트 락업) */
  logos: {
    primary: { src: '/assets/logo.png', alt: 'AdvisorDesk' },
  },
  /** 사업자 정보(푸터) */
  legal: {
    company: '(주)제이앤디소프트',
    ceo: '한준호',
    bizNo: '757-88-02437',
    bizReportNo: '제2026-서울강서-2398호',
    address: '서울특별시 강서구 양천로 424, 데시앙플렉스지식산업센터 630호',
    tel: '070-4167-3202',
    email: 'support@advisordesk.co.kr',
    copyright: '© 2026 JnDSOFT Inc. All rights reserved.',
  },
  /**
   * 고객센터 운영 안내 — 시간 문구 SSoT. 전화번호는 legal.tel 을 공유한다.
   * - `hours`: 한 줄 요약(정의형 목록의 값 등 좁은 자리)
   * - `hoursItems`: 라벨·값 항목 나열(푸터 등 넓은 자리) — 문장형 서술 대신 스캔 가능한 형태
   */
  support: {
    hours: '평일 09:00 ~ 18:00 (점심시간 12:00 ~ 13:00)',
    hoursItems: [
      { label: '상담시간', value: '평일 10:00 ~ 17:00' },
      { label: '점심시간', value: '12:00 ~ 13:00' },
      { label: '휴무', value: '주말 · 공휴일' },
    ],
  },
} as const;

export type Brand = typeof brand;
